import * as service from "../common/service";
import { getCurrentApiBaseUrl } from "../common/constants";

// Dynamic API URL functions that get the current API base URL at runtime
const getCompanyApi = () => `${getCurrentApiBaseUrl()}/user/supplier`;
const getCreateCompany = () => `${getCurrentApiBaseUrl()}/user/supplier-custom`;
const getCustomApi = () => `${getCurrentApiBaseUrl()}/user/custom-field`;

const companyService = {
  getCompanyList: (payload) => {
    let filter = "";
    if (payload && Object.keys(payload).length > 0) {
      filter = Object.keys(payload).reduce(
        (acc, val, index) =>
          Object.keys(payload).length - 1 === index
            ? `${acc}${val}=${payload[val]}`
            : `${acc}${val}=${payload[val]}&`,
        "?"
      );
    }
    return service.get(`${getCompanyApi()}${filter}`, {});
  },
  createCompany: (payload) => {
    return service.postJson(`${getCreateCompany()}`, payload);
  },
  updateCompany: (payload) => {
    return service.putJson(`${getCreateCompany()}`, payload);
  },
  getCompanyCustomDataById: (id) => {
    return service.get(`${getCustomApi()}/data/${id}`, {});
  },
};

export default companyService;
